<template>
  <div class="pageShopFav">
    <XR-head titleText="店铺收藏" r:ightShow="true" ref="headObj"></XR-head>
    
    <div>
      <div class="fav-list">
        <div class="fav-item" v-for="favItem in favList" :key="favItem.ShopId">
          <div class="item-check">
            <mu-checkbox class="fav-checkbox" :nativeValue="favItem.ShopId" v-model="checkList" iconClass="chkbox" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes" />
          </div>
          <router-link :to="getToUrl(favItem)">
            <div class="pro-img"><img :src="favItem.Logo?favItem.Logo:IMGServer_URL+'/images/index-item-default.png'" /></div>
          </router-link>
          <div class="pro-info" :style="{width:proNameWidth+'px'}">
            <router-link :to="getToUrl(favItem)">
              <p class="pro-name">{{favItem.ShopName}}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-bar">
      <div class="chk-button">
        <mu-checkbox @change="checkAll()" label="全选" v-model="checkAllState" class="chkbox" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
      </div>
      <div class="operator-button">
        <mu-flat-button label="取消关注" primary  backgroundColor="red" color="white" @click="cancelFav()" fullWidth />
      </div>
    </div>
    <mu-dialog :open="dialog" title="确定要删除吗" @close="close">      
      <mu-flat-button slot="actions" @click="close" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="close" label="确定"/>
    </mu-dialog>
    <XR-toast @onClose="getFavPage(true)" ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data () {
    return {
      loaded: true,
      proNameWidth:(parseInt(document.documentElement.clientWidth)-160),
      dialog: false,
      activeTab: 'tab1',
      searchInfo:{
        favType: '0',
        pageIndex: 1
      },
      pageEnd:0,
      num:15,
      favList:[],
      skuList:[],
      checkList:[],
      checkAllState:false,
      scrollDone:function(){}
    }
  },
  mounted(){
    this.getFavPage()

  },
  methods: {
    listLength(){
      if(this.favItem.length==0){
        this.$refs.XRPageTip.ShowEmpty('暂无数据')
      }
    },
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    checkAll(){
      if(!this.checkAllState){        
        this.checkList = this.skuList
        
      }else{
        this.checkList = []
      }
    },
    getFavPage(isNewSearch){
      var ths = this; 
           
      ths.$post(
        "/Shop/StoreServer/GetShopsFavoritePage",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        if(!res.IsSuccess){               
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")           
          }
          if(isNewSearch){
            ths.favList = []                   
          }        
        }else{                    
          ths.$refs.XRtoast.hide()
          if(isNewSearch){         
            ths.favList = res.Data.List;                         
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){                         
              ths.favList.push(res.Data.List[i])
            }
          }
          ths.skuList = []
          for(var j = 0; j< ths.favList.length;j++){            
            ths.skuList.push(ths.favList[j].ShopId)
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
          ths.loaded= false
        }
        if(ths.favList.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{       
          ths.$refs.XRPageTip.initTip()  
        }
      });
    },    
    cancelFav(){
      var ths = this;    
      ths.$post(
        "/Shop/StoreServer/CancelShopsFavorite",
        JSON.stringify({shopIds:this.checkList})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }
        else{          
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    getToUrl(favItem){
      if(favItem.FavType == 1){
        return '/shangquan/pingjia?shopId='+favItem.ShopId;
      }else{        
        return '/shop/shopIndex?shopId='+favItem.ShopId;
      }
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getOrderList(false);     
    }
  }
}
</script>
<style>
#app .pageShopFav{
}
.pageShopFav .fav-list{
  overflow: hidden;
  background: white;
  margin-bottom: 56px;
}
.pageShopFav .fav-item{
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding:10px 0;
  display: flex;
  align-items: center;
}
.pageShopFav .item-check{
  float: left;
  width: 40px;
  text-align: center;
}
.pageShopFav .item-check .mu-checkbox-icon-uncheck{
  color:#999;
}
.pageShopFav .pro-img{
  float: left;
  padding: 10px;
  width: 120px;
}
.pageShopFav .pro-img img{
  width: 60px;
  height: 60px;

}
.pageShopFav .pro-info{
  float: left;
  padding: 10px 10px;
}
.pageShopFav .pro-info .pro-name{
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  color:#666;
}
.pageShopFav .pro-info .pro-price{
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
  font-size: 22px;
  color:red;
}
.pageShopFav .pro-info .pro-price .fa{
  font-size: 14px;
}
.pageShopFav .pro-info .pro-jiangjia{
  height: 16px;
  line-height: 16px;
  color:red;
  margin-top: 10px;
  font-size: 12px;
}
.pageShopFav .pro-info .jiangjia-icon{
  height: 16px;
  line-height: 16px;
  color:white;
  background: red;
  font-size: 12px;
  width: 16px;
  text-align: center;
  padding: 0;
}

.pageShopFav .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #eee;
  height: 56px;
  border-top:1px solid #eee;
}
.pageShopFav .bottom-bar .mu-checkbox-icon-uncheck{
  color:#999;
}
.pageShopFav .chk-button{
  float: left;
  margin-top: 14px;
  margin-left: 10px;
  font-size: 14px;
}
.pageShopFav .operator-button{
  float: right;
  line-height: 56px;
}
.pageShopFav .bottom-bar .mu-flat-button{
  height: 56px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/shopFav.vue